<template>
  <div class="h-auto w-full mr-3 min-h-screen">
    <div class="bg-white m-3 rounded-md">
      <form @submit.prevent="editLicensePricing" class="flex flex-col gap-4 ">
        <div class="border-b-0.5 flex justify-between items-center p-3">
          <p class="text-sm font-semibold">Edit Licensing Information</p>
          <button type="submit" class="bg-primary text-white px-3  text-sm py-1  rounded-md my-1">
            Save Changes
          </button>
        </div>
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full">
            <loader class="center-h-v" />
          </div>
        </transition>
        <transition name="fade">
          <div v-if="edit_error" class="p-1 text-center text-sm w-full bg-yellow-200">
            {{ edit_error }}
          </div>
        </transition>


        <transition name="fade">
          <div v-if="showSuccess" class="p-1 text-center text-sm w-full bg-green-200">
            {{ success_msg }}
          </div>
        </transition>
        <div class="flex flex-col md:flex-row gap-5 p-5">
          <div class="p-5  shadow-sm border-0.5 rounded-md">
            <p class="text-lg font-semibold mb-3">Pricing</p>

            <div class="flex text-sm gap-3 items-center mb-3">
              <p>Pricing for (1) HR Manager</p>
              <input v-model="pricing.ManagerPrice" class="bg-gray-200 p-1" type="number" required />
            </div>
            <div class="flex text-sm gap-3 items-center">
              <p>Pricing for (1) Normal User</p>
              <input v-model="pricing.NormalUserPrice" class="bg-gray-200 p-1" type="number" required />
            </div>
          </div>
          <div class="p-5  shadow-sm border-0.5 rounded-md">
            <p class="text-lg font-semibold mb-3">Trial</p>
            <div class="flex flex-col gap-4">
              <div class="flex text-sm gap-3 items-center">
                <p>Trial Days</p>
                <input v-model="pricing.TrialPeriod" class="bg-gray-200 p-1" type="number" required />
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="p-5 overflow-x-auto">
        <p class="text-lg font-semibold mb-3">Payment Terms</p>
        <ve-table :columns="columns" :table-data="tableData"></ve-table>
      </div>
    </div>

  </div>
</template>
<script>
import Loader from "@/components/loader/loader.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "Licensing",
  components: {

    Loader,

  },
  data() {
    return {
      loading: false,
      edit_error: null,
      showSuccess: false,
      success_msg: null,
      pricing: {
        "ManagerPrice": 0,
        "NormalUserPrice": 0,
        "TrialPeriod": 0
      },
      columns: [
        {
          title: '#',
          key: 'title',
          field: '',
          align: 'left',
          headerAlign: 'left',
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          }
        },
        {
          title: 'Name',
          key: 'name',
          field: 'Name',
          align: 'left',
          headerAlign: 'left',
        },
        {
          title: 'Number of Months',
          key: 'numberOfMonths',
          field: 'NumberOfMonths',
        },
        {
          title: 'Action',
          key: 'action',
          field: '',
          renderBodyCell: () => {
            const rowData = { showActions: false }
            const handleClick = (e) => {
              // Prevent the click event from bubbling up and triggering other actions
              e.stopPropagation();

              // Toggle the visibility of the action buttons
              rowData.showActions = !rowData.showActions;
            };

            return (
              <div class="relative">
                <button
                  class="w-6 h-6 text-gray-500 hover:text-gray-900 focus:outline-none"
                  onClick={handleClick}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="15" height="15"><circle cx="12" cy="2" r="2" /><circle cx="12" cy="12" r="2" /><circle cx="12" cy="22" r="2" /></svg>
                </button>

                {/* {rowData.showActions && ( */}
                <div class="absolute z-10 top-8 right-0 w-48 py-2 mt-1 bg-white rounded-md shadow-xl">
                  <button class="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900">
                    Edit
                  </button>
                  <button class="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900">
                    Delete
                  </button>
                </div>
                {/* )} */}
              </div>
            );
          }
        }

      ],
      tableData: [],
    }
  },

  computed: {
    ...mapGetters(["getToken", 'getLicencePricing']),
  },
  created() {
    this.pricing = { ...this.pricing, ...this.getLicencePricing, "ManagerPrice": this.getLicencePricing.ManagersPrice }
    this.getLicenceBillingPeriods()
  },
  methods: {
    // /setup/licence/v1/edit
    editLicensePricing() {

      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };


      axios
        .put(
          `setup/licence/${this.$ApiVersion}/edit`,
          JSON.stringify(this.pricing),
          options
        )
        .then(
          (response) => {

            if (response.data.StatusCode == 200) {
              this.loading = false;
              this.showSuccess = true;
              this.success_msg = response.data.StatusMessage
              setTimeout(() => {
                this.showSuccess = false;
                this.success_msg = null;
              }, 3000);
              this.$emit("closeOnSuccess", response.data.StatusMessage);
            } else {
              this.edit_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
          }
        );
    },
    getLicenceBillingPeriods() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(`setup/v1/request`, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.tableData = response.data.Data.licenceBillingPeriods
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loading = false;
          this.get_error = error.message;
        }
      );
    },
  }
}

</script>

<style scoped></style>
